/* tslint:disable */

export class SeedDatabaseResponse {
		Message: string;

}



// WEBPACK FOOTER //
// D:/a/1/s/src/services/generated/models/SeedDatabaseResponse.ts